import { render, staticRenderFns } from "./AddRules.vue?vue&type=template&id=ff1d8f1e&scoped=true"
import script from "./AddRules.vue?vue&type=script&lang=js"
export * from "./AddRules.vue?vue&type=script&lang=js"
import style0 from "./AddRules.vue?vue&type=style&index=0&id=ff1d8f1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1d8f1e",
  null
  
)

export default component.exports